export default {
  meta: {
    title: '商圈决策报告',
    url: '/standardstore/malldecisionreport',
    urlName: '商圈决策报告',
  },
};
